var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/sanacorp/node_modules/core-js/internals/path.js
// module id = 77
// module chunks = 0